import { baseRequest } from '@/utils/request'

const request = (url, ...arg) => baseRequest(`/biz/dict/` + url, ...arg)
/**
 * 字典
 */
export default {
	// 获取业务字典分页
	gwTree(data) {
		return request('gwTree', data, 'get')
	}
}
